import { useCallback } from 'react'
import { useMaasAccount } from '@maas-tools/accounts'
import lodash from 'lodash'

function useSellerPermissions() {
  const { currentSeller, sellerPermissions } = useMaasAccount()

  const getCurrentPermissions = useCallback(
    service => {
      if (!currentSeller || !sellerPermissions) return false

      const currentSellerPermissions = sellerPermissions[currentSeller.tenantId]

      if (!currentSellerPermissions) return false

      const currentPermissions = currentSellerPermissions[service]

      if (!currentPermissions || currentPermissions.length === 0) return false

      return currentPermissions
    },
    [currentSeller, sellerPermissions]
  )

  const hasPermissions = useCallback(
    verifyPermission => !!getCurrentPermissions(verifyPermission),
    [getCurrentPermissions]
  )

  const hasRoles = useCallback(
    (service, verifyRole) => {
      const currentPermissions = getCurrentPermissions(service)
      if (!currentPermissions) return false
      return currentPermissions.includes(verifyRole)
    },
    [getCurrentPermissions]
  )

  const hasPermissionsInModule = useCallback(
    module => lodash.some(module?.service_id, svc => !!getCurrentPermissions(svc)),
    [getCurrentPermissions]
  )

  return { hasPermissions, hasRoles, hasPermissionsInModule }
}

export default useSellerPermissions
